import AGENCY_API from '@/api/agencyContract/index';
import { COMPANY_CODE1 } from '@/constants';
import BASE_API from '@/api/dataBase';
export const baseForm = (ctx) => {
  return [
    {
      prop: 'contractName',
      name: '合同名称',
      type: 'input',
      maxlength: 100,
      // disabled: cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT061',
      placeholder: '请输入合同名称',
    },
    {
      prop: 'contractBusinessCompanyNo',
      name: '公司',
      type: 'select',
      options: ctx.companyList,
      // disabled: cs == 'ZT02' || (cs == 'ZT03' && cs != 'ZT061'),
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractType',
      name: '合同类别',
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'serviceContractType' },
      changeMethod: 'changeMethod',
    },
    {
      prop: 'customerName',
      name: '客户名称',
      type: 'searchTableSpec',
      searchType: 'partner',
      placeholder: '请输入客户名称',
      isMultiple: true,
      // disabled: cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT061',
      currentValue: ctx.baseFormData.customerName,
      extraData: {
        companyCode: ctx.userInfo.companyCode,
        departmentCode: ctx.userInfo.departmentCode,
        partnerTypes: 'HZHB01,HZHB03,HZHB11,HZHB10',
      },
      changeMethod: 'changeMethod',
    },
    {
      prop: 'projectInitiationNo',
      name: '项目编号',
      searchType: 'projectListWumao',
      type: 'searchTableSpec',
      isMultiple: true,
      // disabled: cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT061',
      currentValue: ctx.baseFormData.projectInitiationNo,
      // checkRowKeys: [ctx.baseFormData.projectInitiationNo],
      extraData: {
        projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
        platformtCompany: ctx.baseFormData.companyCode,
        platformtCompanyName: ctx.baseFormData.companyName,
        applyCompanyNo: ctx.baseFormData.companyCode,
        applyCompanyName: ctx.baseFormData.companyName,
        // applyDepartmentName: ctx.baseFormData.departmentName,
      },
      changeMethod: 'changeMethod',
    },

    {
      prop: 'projectName',
      name: '项目名称',
      type: 'input',
      disabled: true,
      placeholder: '请输入项目名称',
    },
    {
      prop: 'platformCompanyFileNo',
      name: '平台公司',
      type: 'select',
      options: ctx.platformCompanyFileList,
      placeholder: '请选择平台公司',
      changeMethod: 'changeMethod',
      // disabled: cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT061',
    },
    {
      prop: 'platformCompanyFileNo',
      name: '平台公司档案编号',
      type: 'input',
      disabled: true,
    },

    {
      prop: 'contractNo',
      name: '合同编号',
      type: 'input',
      disabled: true,
      placeholder: '自动生成',
    },
    {
      prop: 'externalContractNo',
      name: '外部合同号',
      type: 'input',
      // disabled: cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT061',
      placeholder: '请输入外部合同号',
    },
    {
      prop: 'purchaseQuantity',
      name: '合同数量',
      type: 'inputNumber',
      disabled: true,
      placeholder: '自动填写',
    },
    {
      prop: 'contractTotalAmount',
      name: '合同总金额',
      type: 'inputNumber',
      precision: 6,
      disabled: true,
      placeholder: '请输入合同总金额',
    },
    {
      prop: 'signDate',
      name: '合同签署日期',
      type: 'date',
      // disabled:
      // cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
    },
    {
      prop: 'contractValidStart',
      name: '合同生效日期',
      type: 'date',
      changeMethod: 'changeMethod',
      // disabled:
      //   cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
    },
    {
      prop: 'contractValidEnd',
      name: '合同到期日期',
      type: 'date',
      changeMethod: 'changeMethod',
      // disabled:
      //   cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
    },
    {
      prop: 'isNotEndDate',
      name: '至合同履行截止日止',
      labelPosition: 'right',
      falseLable: '0',
      trueLable: '1',
      type: 'checkbox',
    },
    {
      prop: 'isDefault',
      name: '是否有违约责任',
      type: 'checkbox',
      falseLable: '0',
      trueLable: '1',
      changeMethod: 'changeChecked',
    },

    {
      prop: 'contractBusinessDepartment',
      name: '业务部门',
      type: 'select',
      options: ctx.departmentList,
      changeMethod: 'changeMethod',
      // disabled:
      //   (cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT061') ||
      //   ctx.baseFormData.contractBusinessCompanyNo == '',
    },
    {
      prop: 'personChargeName',
      name: '部门负责人',
      type: 'searchTableSpec',
      searchType: 'personnel',
      isMultiple: true,
      currentValue: ctx.baseFormData.personChargeName,
      // disabled:
      //   cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractCreateDate',
      name: '制单日期',
      type: 'date',
      disabled: true,
      placeholder: '自动生成',
    },
    ctx.$route.query.copyFlag == 0
      ? {
          prop: 'contractOperaterName',
          name: '经办人',
          placeholder: '请选择经办人',
          type: 'searchTableSpec',
          searchType: 'personnel',
          isMultiple: true,
          extraData: {
            personCompanyCode: ctx.userInfo.companyCode,
          },
          currentValue: ctx.baseFormData?.contractOperaterName,
          changeMethod: 'changeMethod',
        }
      : {
          prop: 'contractOperaterName',
          name: '经办人',
          type: 'input',
          disabled: true,
        },
    // {
    //   prop: 'settlementDate',
    //   name: '结算日',
    //   apiUrl: BASE_API.DIC_CREDIT_API,
    //   apiData: { dictType: 'settlementDate' },
    //   type: 'ajaxSelect',
    //   placeholder: '请选择结算日',
    //   changeMethod: 'changeMethod',
    // },
    {
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'liquidatedDamages' },
      type: 'ajaxSelect',
      name: '合同违约金类型',
      prop: 'liquidatedDamagesType',
      changeMethod: 'changeMethod',
    },
    //wumao
    {
      prop: 'liquidatedFixedValue',
      name: '违约金固定值',
      type: 'inputNumber',
      placeholder: '请输入违约金固定值',
      precision: 2,
      append: '元',
      changeMethod: 'changeMethod',
    },
    //wumao
    {
      prop: 'liquidatedInterestRate',
      name: '违约金日利率',
      type: 'inputNumber',
      placeholder: '请输入违约金日利率',
      precision: 6,
      append: '%',
      changeMethod: 'changeMethod',
    },
    // {
    //   type: 'inputNumber',
    //   prop: 'marginAmount',
    //   name: '保证金',
    //   precision: 2,
    //   append: '元',
    // },
    //wumaoFix
    {
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'qualityGuaranteeDepositMethod' },
      name: '质保金收取方式',
      prop: 'qualityGuaranteeDepositMethodCode',
      changeMethod: 'changeMethod',
    },
    //wumaoFix
    {
      prop: 'chargeFixedValue',
      name: '收取固定值',
      type: 'inputNumber',
      precision: 2,
      append: '元',
      changeMethod: 'changeMethod',
    },
    //wumaoFix
    {
      prop: 'chargeProportion',
      name: '收取比例',
      append: '%',
      precision: 2,
      type: 'inputNumber',
      changeMethod: 'changeMethod',
    },
    //wumaoFix
    {
      type: 'inputNumber',
      prop: 'qualityGuaranteeDepositOverdue',
      name: '质保金逾期期限',
      precision: 0,
      append: '天',
    },
    //wumaoFix

    {
      prop: 'performanceBondPayMethodCode',
      name: '履约保证金缴纳方式',
      type: 'select',
      options: ctx.dictListMap?.apply_payment_method || [],
      // disabled:
      //   cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'performanceBond',
      name: '履约保证金',
      // disabled:
      //   cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
      type: 'inputNumber',
      placeholder: '请输入履约保证金',
      precision: 2,
      append: '元',
    },
    // {
    //   prop: 'overduePeriod',
    //   name: '逾期周期',
    //   type: 'inputNumber',
    //   precision: 0,
    //   append: '天',
    // },
    //wumao   FIXED/RATE

    {
      prop: 'warrantyClause',
      name: '保供条款',
      type: 'input',
      // disabled:
      //   cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
      placeholder: '请输入保供条款',
    },
    {
      prop: 'overShippedPercentage',
      name: '溢装比例',
      type: 'inputNumber',
      max: 100,
      // disabled:
      //   cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
      append: '%',
    },
    {
      prop: 'shortShippedPercentage',
      name: '短装比例',
      type: 'inputNumber',
      max: 100,
      // disabled:
      //   cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
      append: '%',
    },
    {
      prop: 'businessType',
      name: '业务性质',
      type: 'ajaxSelect',
      clearable: false,
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'purchase_business_type' },
      placeholder: '请选择业务性质',
    },

    //wumaoFix

    // {
    //   prop: 'contractBusinessDepartmentName',
    //   name: '业务部门',
    //   type: 'select',
    //   options: ctx.departmentList,
    //   changeMethod: 'changeMethod',
    //   disabled: (cs != '' && cs != 'ZT06' && cs != 'ZT05') || ctx.baseFormData.companyCode == '',
    // },

    // {
    //   prop: 'recyclingCompanyFileNo',
    //   name: '回收公司',
    //   type: 'select',
    //   options: ctx.recyclingCompanyFileList,
    //   changeMethod: 'changeMethod',
    //   // disabled: cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT061',
    // },
    // {
    //   prop: 'recyclingCompanyFileNo',
    //   name: '回收公司档案编号',
    //   type: 'input',
    //   disabled: true,
    // },
    {
      prop: 'isFixedPrice',
      name: '不定价',
      type: 'checkbox',
      falseLable: '0',
      trueLable: '1',
      disabled: true,
      changeMethod: 'changeMethod',
    },
    //不定价时必输 wumaoFix
    {
      prop: 'pricingRule',
      name: '定价模式',
      type: 'ajaxSelect',
      clearable: true,
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'pricing_rule' },
      changeMethod: 'changeMethod',
    },

    {
      prop: 'receiptMethod',
      name: '收款方式',
      type: 'select',
      label: 'label',
      value: 'value',
      options: ctx.dictListMap?.apply_payment_method || [],
      // disabled:
      //   cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
    },
    {
      prop: 'contractCurrency',
      type: 'ajaxSelect',
      name: '币种',
      apiUrl: AGENCY_API.LIST_CURRENCY,
      method: 'get',
      apiData: { isEnabled: 1 },
      valueKey: 'currencyCode',
      moreShowKey: 'currencyCode',
      labelKey: 'currencyName',
      valueType: 'object',
      changeMethod: 'changeMethod',
      // disabled: cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT061',
    },
    //wumaoFix

    //wumaoFix

    //wumaoFix
    {
      prop: 'incomeMethod',
      name: '收益方式',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'incomeMethod' },
      type: 'ajaxSelect',
      placeholder: '请选择收益方式',
    },
    //wumao

    //wumao

    {
      prop: 'isRestrict',
      name: '是否定量',
      type: 'select',
      changeMethod: 'changeMethod',
      options: [
        {
          value: '0',
          label: '否',
        },
        {
          value: '1',
          label: '是',
        },
      ],
      // disabled:
      //   (cs != '' &&
      //     cs != 'ZT06' &&
      //     cs != 'ZT05' &&
      //     cs != 'ZT051' &&
      //     cs != 'ZT021' &&
      //     cs != 'ZT061') ||
      //   ctx.disabledIsRestrict,
    },
    {
      prop: 'isLongRange',
      name: '是否长期合同',
      type: 'select',
      options: [
        {
          value: '0',
          label: '否',
        },
        {
          value: '1',
          label: '是',
        },
      ],
    },
    {
      prop: 'performanceBondRecipient',
      name: '保证金收取方',
      type: 'select',
      options: [
        {
          value: '01',
          label: '我方',
        },
        {
          value: '02',
          label: '客方',
        },
      ],
    },
    {
      prop: 'mark',
      name: '备注',
      type: 'textarea',
      span: 24,
      maxlength: 512,
      // disabled:
      //   cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
    },
  ];
};

export const baseFormRule = (ctx) => {
  return {
    contractName: [{ required: true, message: '必填字段', trigger: 'blur' }],
    customerName: [{ required: true, message: '必填字段', trigger: 'change' }],
    projectInitiationNo: [{ required: true, message: '必填字段', trigger: 'change' }],
    personChargeName: [{ required: true, message: '必填字段', trigger: 'change' }],
    //wumaoFix
    contractBusinessCompanyNo: [{ required: true, message: '必填字段', trigger: 'change' }],
    settlementDate: [{ required: true, message: '必填字段', trigger: 'change' }],
    // isDefault: [{ required: true, message: '必填字段', trigger: 'change' }],

    contractBusinessDepartment: [{ required: true, message: '必填字段', trigger: 'change' }],
    // recyclingCompanyFileNo: [{ required: true, message: '必填字段', trigger: 'blur' }],
    platformCompanyFileNo: [{ required: true, message: '必填字段', trigger: 'blur' }],
    contractCurrency: [{ required: true, message: '必填字段', trigger: 'change' }],
    isRestrict: [{ required: true, message: '必填字段', trigger: ['blur'] }],
    isLongRange: [{ required: true, message: '必填字段', trigger: ['blur'] }],
    businessType: [{ required: true, message: '必填字段', trigger: 'change' }],
    pricingRule: [
      {
        required: ctx.baseFormData.isFixedPrice && ctx.baseFormData.isFixedPrice == 1,
        message: '必填字段',
        trigger: 'blur',
      },
    ],
    contractValidEnd: [
      {
        required: COMPANY_CODE1.includes(ctx.baseFormData.contractBusinessCompanyNo) ? true : false, // 只要城矿公司需要校验
        message: '必填字段',
        trigger: 'blur',
      },
    ],
    contractValidStart: [
      {
        required: COMPANY_CODE1.includes(ctx.baseFormData.contractBusinessCompanyNo) ? true : false, // 只要城矿公司需要校验
        message: '必填字段',
        trigger: 'blur',
      },
    ],
    signDate: [
      {
        required: COMPANY_CODE1.includes(ctx.baseFormData.contractBusinessCompanyNo) ? true : false, // 只要城矿公司需要校验
        message: '必填字段',
        trigger: 'blur',
      },
    ],
  };
};
